import { Route } from "@angular/router";
import { authGuard } from "@core/guards";
import {
  OutgoingEmailMessagesPageComponent
} from "./components/outgoing-email-messages-page/outgoing-email-messages-page.component";
import {
  OutgoingSmsMessagesPageComponent
} from "./components/outgoing-sms-messages-page/outgoing-sms-messages-page.component";

export function getOutgoingMessagesRoutes(): Route[] {
  return [
    {
      path: 'outgoing-messages',
      title: 'Outgoing Messages',
      canActivate: [authGuard],
      canActivateChild: [authGuard],
      children: [
        {
          path: 'email',
          component: OutgoingEmailMessagesPageComponent,
          title: 'Outgoing Email Messages'
        },
        {
          path: 'sms',
          component: OutgoingSmsMessagesPageComponent,
          title: 'Outgoing SMS Messages'
        },
        { path: '**', redirectTo: 'email' },
      ]
    },
  ];
}
